import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { ShopService } from '@app/services/shops/shop.service';
import { Store } from '@ngrx/store';
import { ColorEnum, colorEnumToColorNameMap, OrderStatus } from '@pdqdev/pdq-shared/dist/entities';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators';
import { createStepFilter } from 'src/utils';
import { Filter, QueryParameters, SortField, WrapFilter } from '../../../../../core/entities/query-parameters.class';
import { Shop } from '../../../../../services/shops/shop.model';
import { AdvancedFilter } from '../../../../../sharedModule/models/advanced-filter.model';
import { OrderTag } from '../../../../../sharedModule/models/order-tag.model';
import { ProductTag } from '../../../../../sharedModule/models/product-tag.model';
import { AdvancedFilterRequest } from '../../entities/advanced-filter-request.class';
import { AddFiltersService } from '../../services/add-filters.service';
import { AdvancedFilterService } from '../../services/advanced-filter/advanced-filter.service';
import { AdvancedFiltersActions } from '../../store/actions';
import { AdvancedFilterDeleteDialogComponent } from '../advanced-filter-delete-dialog/advanced-filter-delete-dialog.component';
import {
  AutocompleteResult,
  BackendFilterConditionOperators,
  BackendFilterConditionSubOperators,
  BackendFilterEntities,
  filterCategory,
  FilterConditionOperators,
  FilterEntities,
  FilterEntitiesDisplay,
  initFormConfig,
  InputSubType,
  InputType,
  rulesTypesOptionsConfig,
} from '../advanced-filters/config/models';

const DEFAULT_ADVANCED_FILTER = 'ready';
const EMPTY_VALUE_STRING = '';

@Component({
  selector: 'app-advanced-filters-manage-side',
  templateUrl: './advanced-filters-manage-side.html',
  styleUrls: ['./advanced-filters-manage-side.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AdvancedFiltersManageSide implements OnInit, OnDestroy {
  MAX_CHARS: number = 14;
  MAX_LENGTH_PINNED_ARRAY = 3;
  @ViewChild('inputRef') inputRef: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @Input() localStoragePinnedArrayKey: string;
  @Input() localStoragePriorityUnPinnedArrayKey: string;
  @Input() drawer;
  @Input() selectedActiveFilters: AdvancedFilter[] = [];
  @Input() advancedFilters: AdvancedFilter[];
  @Input() pinnedArray: AdvancedFilter[];
  @Input() regularAdvancedFilterArray: AdvancedFilter[];
  @Output() onClearAllSelected = new EventEmitter<AdvancedFilter[]>();
  @Output() onSelectedFilters = new EventEmitter<AdvancedFilter[]>();
  @Output() onAdvancedFiltersArrayUpdate = new EventEmitter<AdvancedFilter[]>();
  @Output() onPinnedArrayUpdate = new EventEmitter<AdvancedFilter[]>();
  @Output() saveDetect = new EventEmitter<boolean>();

  advancedFilter: AdvancedFilter;
  advancedFiltersForm: UntypedFormGroup;
  rulesTypesOptions = [...rulesTypesOptionsConfig];
  initFormConfigFields = [...initFormConfig];
  filterCategory = [...filterCategory];
  inputType = InputType;
  inputSubType = InputSubType;
  filterEntities = FilterEntities;
  filterCategoryOperators: FilterConditionOperators[] = [];
  isLoadingAutoComplete = false;
  autocompleteOptionsArray: { id: string; name: string; type: string }[] = [];
  isFormValid = false;
  filterName: string;
  selectRule: string;
  conditionEntity: string;
  chipInput = new UntypedFormControl();
  showIndex: number = -1;
  state: string = 'default';
  expandFilterInfo: string[] = [];
  advancedFilterId: number;
  showDiv: string;
  errorMessage: string;
  showError: boolean = false;
  freeSearch: string;
  filterEntity: string;
  controlsSubscription$: Subscription;
  autocompleteList: AutocompleteResult[] = [];
  maximumAutocompleteWidth: number = 400;
  inventoryLocationsNamesMap = {};
  shop$: Observable<Shop>;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private advancedFilterService: AdvancedFilterService,
    private eventService: AddFiltersService,
    private eRef: ElementRef,
    private store: Store,
    private shopService: ShopService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadFilterCategoryOperators();
    this.loadPinnedFilters();
    this.advancedFilterService.loadDeliveryMethodOptions();
    this.advancedFilterService.loadPackageNameOptions();
    this.advancedFilterService.loadInventoryLocationOptions();
    this.advancedFilterService.loadCountriesOptions();
    this.shop$ = this.shopService.shop$;
  }

  ngOnDestroy(): void {
    this.closeAutocomplete();
  }

  loadFilterCategoryOperators(): void {
    this.filterCategory.map((filter) => {
      filter.operators.map((operator: FilterConditionOperators) => {
        this.filterCategoryOperators.push(operator);
      });
    });
  }

  loadPinnedFilters(): void {
    this.pinnedArray = JSON.parse(localStorage.getItem(this.localStoragePinnedArrayKey)) ?? [];
  }

  //init form fields
  private initForm(): void {
    this.advancedFiltersForm = this.formBuilder.group(this.initFields());
  }

  //Edit and duplicate filter, indicates by advancedFilter ID
  onLoadAdvancedFilter(event, advancedFilter: AdvancedFilter, loadFilter: boolean): void {
    // TODO: refactor this function
    event.stopPropagation();
    this.divToggle('addFilter');
    if (loadFilter) {
      this.filterName = advancedFilter.name;
      this.advancedFilterId = advancedFilter.id;
      this.selectRule = advancedFilter.queryParametersJson.anyAll;
    }
    console.log('advanced filter: ', advancedFilter);
    advancedFilter?.filter?.filters.map((filter) => {
      console.log('value: ', this.parceFilterValues(filter.values, this.convertFilterEntityDBtoUI(filter.fieldName)));
      const filterEntity = this.convertFilterEntityDBtoUI(filter.fieldName);

      const newFilterRow = this.formBuilder.group({
        filterEntity: filterEntity,
        conditionEntity: this.convertFilterConditionOperatorDBtoUI(filter.operator, filter.subOperator, filterEntity),
        isStoredAutocompleteObjects: this.isStoreAutocompleteObjects(filter.fieldName),
        value: this.parceFilterValues(filter.values, this.convertFilterEntityDBtoUI(filter.fieldName)),
      });
      console.log('newFilterRos: ', newFilterRow);
      this.filtersField.push(newFilterRow);
    });
    advancedFilter?.filter?.wrapFilters.map((wrapFilter) => {
      const EXPECTED_FILTER_COUNT = 2;
      const hasValidFilterCount = wrapFilter.filters.length === EXPECTED_FILTER_COUNT;
      if (!hasValidFilterCount) {
        console.log(`Invalid WrapFilter: expected ${EXPECTED_FILTER_COUNT} filters, got ${wrapFilter.filters.length}`);
        return;
      }
      const filter1 = wrapFilter.filters[0]; // Display only first filter - save operation will regenerate both filters to the adjusted entities
      const filterEntity = this.convertFilterEntityDBtoUI(filter1.fieldName);
      const newFilterRow = this.formBuilder.group({
        filterEntity: filterEntity,
        conditionEntity: this.convertFilterConditionOperatorDBtoUI(filter1.operator, filter1.subOperator, filterEntity),
        isStoredAutocompleteObjects: this.isStoreAutocompleteObjects(filter1.fieldName),
        value: this.parceFilterValues(filter1.values, this.convertFilterEntityDBtoUI(filter1.fieldName)),
      });
      this.filtersField.push(newFilterRow);
    });
    this.checkValidation();
    this.resetAddFilterFields();
  }

  onPinnedRow(event, advancedFilter: AdvancedFilter): void {
    this.selectedActiveFilters = undefined;
    this.onClearAllSelected.emit(this.selectedActiveFilters);
    event.stopPropagation();
    if (this.pinnedArray == null || undefined) {
      this.pinnedArray = [];
      this.pinnedArray.push(advancedFilter);
      localStorage.setItem(this.localStoragePinnedArrayKey, JSON.stringify(this.pinnedArray));
    }
    if (this.pinnedArray?.length <= this.MAX_LENGTH_PINNED_ARRAY) {
      if (this.pinnedArray?.length == this.MAX_LENGTH_PINNED_ARRAY) {
        this.regularAdvancedFilterArray.push(this.pinnedArray.pop());
      }
      this.pinnedArray.push(advancedFilter);
      localStorage.setItem(this.localStoragePinnedArrayKey, JSON.stringify(this.pinnedArray));
      this.removeFilterFromAdvancedFilterArray(event, advancedFilter);
    }
    this.onPinnedArrayUpdate.emit(this.pinnedArray);
    this.onAdvancedFiltersArrayUpdate.emit(this.regularAdvancedFilterArray);
  }

  onUnPinnedRow(event, advancedFilter: AdvancedFilter): void {
    this.selectedActiveFilters = undefined;
    this.onClearAllSelected.emit(this.selectedActiveFilters);
    event.stopPropagation();
    this.regularAdvancedFilterArray.push(advancedFilter);
    this.removeFilterFromPinnedArray(event, advancedFilter);
    this.onPinnedArrayUpdate.emit(this.pinnedArray);
    this.onAdvancedFiltersArrayUpdate.emit(this.regularAdvancedFilterArray);
  }

  removeFilterFromAdvancedFilterArray(event, advancedFilter: AdvancedFilter) {
    event.stopPropagation();
    this.regularAdvancedFilterArray = this.regularAdvancedFilterArray.filter((obj) => {
      return obj.id !== advancedFilter.id;
    });
  }

  removeFilterFromPinnedArray(event, advancedFilter: AdvancedFilter) {
    event.stopPropagation();
    this.pinnedArray = this.pinnedArray.filter((obj) => {
      return obj.id !== advancedFilter.id;
    });
    localStorage.setItem(this.localStoragePinnedArrayKey, JSON.stringify(this.pinnedArray));
  }

  initFields() {
    const initFields = {};
    this.initFormConfigFields.forEach((field) => {
      if (field.fieldName === 'filters') {
        initFields[field.fieldName] = this.formBuilder.array([]);
      } else {
        initFields[field.fieldName] = [field.defaultValue];
      }
    });
    console.log('initFields: ', JSON.stringify(initFields));
    return initFields;
  }

  identify(index, item) {
    return item.name;
  }

  isFilterValueFreeText(operator: FilterConditionOperators) {
    if (!operator) return false;

    return [
      FilterConditionOperators.STARTS_WITH,
      FilterConditionOperators.NOT_STARTS_WITH,
      FilterConditionOperators.CONTAINS,
      FilterConditionOperators.NOT_CONTAINS,
    ].includes(operator);
  }

  onSelectedOption(event): void {
    this.inputRef.nativeElement.value = event.option.value.name;
  }

  onExpandRow(event, showIndex: number, advancedFilter: AdvancedFilter): void {
    this.expandFilterInfo = [];
    event.stopPropagation();
    this.state = this.state === 'default' ? 'rotated' : 'default';
    this.showIndex === showIndex ? (this.showIndex = -1) : (this.showIndex = showIndex);

    advancedFilter?.filter?.filters.forEach((filter) => {
      const filterEntity = this.convertFilterEntityDBtoUI(filter.fieldName);
      const filterEntityDisplayText = this.getFilterConditionEntityDisplay(filterEntity);
      const info = `${filterEntityDisplayText} ${this.convertFilterConditionOperatorDBtoUI(
        filter?.operator,
        filter?.subOperator,
        filterEntity,
      )?.toLowerCase?.()} ${
        filterEntity === FilterEntities.COLOR_CODING
          ? filter?.values.map((color) => colorEnumToColorNameMap.get(color)).join(', ')
          : filter?.values[0]?.name
            ? filter?.values[0]?.name
            : filter.values[0]
      }`;
      this.expandFilterInfo.push(info);
    });
  }

  onDeleteFilter(event, advancedFilterId: number, advancedFilterName: string, advancedFilter?: AdvancedFilter): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(AdvancedFilterDeleteDialogComponent, {
      maxWidth: '100vw',
      width: '25vw',
      backdropClass: 'global_modal_overlay',
      panelClass: 'delete-advanced-filter',
      data: { id: advancedFilterId, name: advancedFilterName },
    });

    const deleteAdvancedFilterSubscription$ = dialogRef.componentInstance.onDeleteAdvancedFilter.subscribe(
      (filterId: number) => {
        this.store.dispatch(AdvancedFiltersActions.deleteAdvancedFilter({ filterId }));

        if (this.advancedFilterId === filterId) {
          this.eventService.changeFilter(DEFAULT_ADVANCED_FILTER);
        }
        this.removeFilterFromPinnedArray(event, advancedFilter);
        this.removeFilterFromAdvancedFilterArray(event, advancedFilter);
        this.onPinnedArrayUpdate.emit(this.pinnedArray);
        this.onAdvancedFiltersArrayUpdate.emit(this.regularAdvancedFilterArray);
      },
    );

    dialogRef.afterClosed().subscribe(() => {
      this.clickResetSelected(event);
      deleteAdvancedFilterSubscription$.unsubscribe();
    });
  }

  onAddLine(): void {
    this.onAddPotentialFilter(this.advancedFiltersForm.value);
    this.closeAutocomplete();
  }

  removeLine(index: number): void {
    if (this.filtersField.length > 0) {
      this.filtersField.removeAt(index);
    }
  }

  get filtersField(): UntypedFormArray {
    return this.advancedFiltersForm.get('filters') as UntypedFormArray;
  }

  clearFiltersField(): void {
    (this.advancedFiltersForm.controls['filters'] as UntypedFormArray).clear();
    this.initForm();
  }

  clickResetSelected(event): void {
    this.onClearAllSelected.emit(undefined);
  }

  validatePotentialFilter(values: any): boolean {
    // TODO: refactor + check input type
    if (!values.value?.selectRule) {
      this.errorMessage = 'You Must choose All or Any';
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 5000);
      return false;
    } else if (!values.value?.conditionEntity || !values.value?.selectRule) {
      this.errorMessage = `Please Fill All Fields`;
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 5000);
      return false;
    } else if (!values.value?.value?.length) {
      this.errorMessage = `Must Supply Filter Value`;
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 5000);
      return false;
    } else {
      this.errorMessage = undefined;
      return true;
    }
  }

  private resetAddFilterFields(): void {
    // TODO: refactor
    this.advancedFiltersForm.controls.filterEntity.setValue(null);
    this.advancedFiltersForm.controls.filterEntity.setValidators(Validators.required);
    this.advancedFiltersForm.controls.filterEntity.updateValueAndValidity();
    this.advancedFiltersForm.controls.conditionEntity.setValue(null);
    this.advancedFiltersForm.controls.conditionEntity.setValidators(Validators.required);
    this.advancedFiltersForm.controls.conditionEntity.updateValueAndValidity();

    this.advancedFiltersForm.controls.param1.setValue(null);
    this.advancedFiltersForm.controls.param2.setValue(null);
    this.advancedFiltersForm.controls.param1.setValidators(Validators.required);
  }

  private onAddPotentialFilter(values?: any): void {
    // TODO: refactor
    const newFilterRow = this.formBuilder.group(this.initPotentialFilter(values));
    if (this.validatePotentialFilter(newFilterRow)) {
      this.filtersField.push(newFilterRow);
      this.checkValidation();
      this.resetAddFilterFields();
    }
  }

  private initPotentialFilter(values: any) {
    // TODO: refactor this function
    const initFilter: any = {};
    initFilter.selectRule = values.selectRule;
    initFilter.filterEntity = values.filterEntity;
    initFilter.conditionEntity = values.conditionEntity;
    initFilter.isStoredAutocompleteObjects = this.isPotentialFilterStoresObjects(
      values.filterEntity,
      values.conditionEntity,
    );
    initFilter.value = this.generatePotentialFilterValue(values.param1, values.filterEntity, values.conditionEntity);

    return initFilter;
  }

  isPotentialFilterStoresObjects(filterEntity: FilterEntities, conditionEntity: FilterConditionOperators) {
    if (
      filterEntity === FilterEntities.TAG &&
      (conditionEntity === FilterConditionOperators.INCLUDE || conditionEntity === FilterConditionOperators.EXCLUDE)
    ) {
      return true;
    }

    return false;
  }

  generatePotentialFilterValue(value: any, filterEntity: FilterEntities, condition: FilterConditionOperators) {
    if (
      filterEntity === FilterEntities.SKU &&
      (condition === FilterConditionOperators.INCLUDE || condition === FilterConditionOperators.EXCLUDE)
    ) {
      return [value.map((val) => val.value)];
    }

    if (
      filterEntity === FilterEntities.TAG &&
      (condition === FilterConditionOperators.INCLUDE || condition === FilterConditionOperators.EXCLUDE)
    ) {
      return [value.map((val) => ({ type: val.type, id: val.value, name: val.label }))];
    }

    if (filterEntity === FilterEntities.COLOR_CODING) {
      return [value];
    }

    if (value === EMPTY_VALUE_STRING) {
      return null;
    }

    return [[value]];
  }

  private buildRequestObject(filterName: string): AdvancedFilterRequest {
    // TODO: refactor this function
    const advancedFilterRequest = new AdvancedFilterRequest();
    advancedFilterRequest.name = filterName;
    if (this?.advancedFilterId) {
      advancedFilterRequest.id = this.advancedFilterId;
    }
    const queryParameters = new QueryParameters();
    queryParameters.stepFilter = createStepFilter(OrderStatus.STEP_ASSIGN);
    queryParameters.sortFields = [new SortField('orderNumber', 'DESC')];
    queryParameters.filters = [];
    queryParameters.wrapFilters = [];
    queryParameters.anyAll = this.advancedFiltersForm.value.selectRule
      ? this.advancedFiltersForm.value.selectRule
      : 'all';

    this.advancedFiltersForm.value.filters.forEach((filterSelection) => {
      queryParameters.filters.push(...this.generateFiltersArray(filterSelection));
      queryParameters.wrapFilters.push(...this.generateWrapFiltersArray(filterSelection));
    });

    advancedFilterRequest.queryParameters = queryParameters;
    return advancedFilterRequest;
  }
  generateWrapFiltersArray(filterSelection: any) {
    const filterEntity = filterSelection.filterEntity;
    const conditionEntity = filterSelection.conditionEntity;
    const values = filterSelection.value;

    const operatorsData = AdvancedFiltersManageSide.convertFilterConditionOperatorUItoDB(conditionEntity);

    const resultArr: WrapFilter[] = [];

    if (filterEntity === FilterEntities.TAG) {
      const isConditionForAutocomplete = this.isConditionAutocompleteType(conditionEntity);

      if (!isConditionForAutocomplete) {
        let operatorBetweenFilters;
        switch (operatorsData.operator) {
          case BackendFilterConditionOperators.NOT_CONTAINS:
          case BackendFilterConditionOperators.NOT_STARTS_WITH:
            operatorBetweenFilters = 'AND';
            break;
          case BackendFilterConditionOperators.CONTAINS:
          case BackendFilterConditionOperators.STARTS_WITH:
          default:
            operatorBetweenFilters = 'OR';
            break;
        }
        resultArr.push(
          new WrapFilter(
            [
              new Filter(
                BackendFilterEntities.PRODUCT_TAG_NAME,
                operatorsData.operator,
                values,
                null,
                operatorsData.subOperator,
              ),
              new Filter(
                BackendFilterEntities.ORDER_TAG_NAME,
                operatorsData.operator,
                values,
                null,
                operatorsData.subOperator,
              ),
            ],
            operatorBetweenFilters,
          ),
        );
      }
    }

    console.log('WRAP FILTERS RESULT ARR: ', resultArr);
    return resultArr;
  }

  isConditionAutocompleteType(conditionEntity: FilterConditionOperators) {
    if (conditionEntity === FilterConditionOperators.INCLUDE || conditionEntity === FilterConditionOperators.EXCLUDE) {
      return true;
    }

    return false;
  }

  generateFiltersArray(filterSelection) {
    const filterEntity = filterSelection.filterEntity;
    const conditionEntity = filterSelection.conditionEntity;
    const values = filterSelection.value;

    const operatorsData = AdvancedFiltersManageSide.convertFilterConditionOperatorUItoDB(conditionEntity);

    const resultArr: Filter[] = [];

    if (filterEntity === FilterEntities.TAG) {
      const productTypeTags = values?.filter((val) => val.type === 'productTag')?.map((val) => val.id);
      const ordeItemsTypeTags = values?.filter((val) => val.type === 'orderTag')?.map((val) => val.id);
      const isConditionForAutocomplete = this.isConditionAutocompleteType(conditionEntity);

      if (isConditionForAutocomplete) {
        if (productTypeTags?.length > 0) {
          resultArr.push(
            new Filter(
              BackendFilterEntities.PRODUCT_TAG_ID,
              operatorsData.operator,
              productTypeTags,
              null,
              operatorsData.subOperator,
            ),
          );
        }
        if (ordeItemsTypeTags?.length > 0) {
          resultArr.push(
            new Filter(
              BackendFilterEntities.ORDER_TAG_ID,
              operatorsData.operator,
              ordeItemsTypeTags,
              null,
              operatorsData.subOperator,
            ),
          );
        }
      }
    } else {
      const filterEntityData = this.convertFilterEntityUItoDB(filterEntity);
      resultArr.push(new Filter(filterEntityData, operatorsData.operator, values, null, operatorsData.subOperator));
    }

    console.log('RESULT ARR: ', resultArr);
    return resultArr;
  }

  saveAdvancedFilter(event): void {
    if (this.checkValidation() && this.selectRule.length > 1) {
      this.advancedFilterService
        .addAdvancedFilter(this.buildRequestObject(this.advancedFiltersForm.value.filterName))
        .subscribe((newFilter: AdvancedFilter) => {
          this.store.dispatch(AdvancedFiltersActions.refreshAdvancedFilters());
          newFilter.filter = newFilter?.queryParametersJson ? newFilter.queryParametersJson : null;
        });
      this.eventService.emitAdvancedFilter(DEFAULT_ADVANCED_FILTER);
      this.saveDetect.emit(true);
      this.goManage();
    } else {
      this.showError = true;
      this.errorMessage = `Please Insert at least one rule`;
      setTimeout(() => {
        this.showError = false;
      }, 5000);
    }
    this.clearFiltersField();
    this.resetAddFilterFields();
    this.clickResetSelected(event);
  }

  onChangeFilter({ value }): void {
    this.selectedActiveFilters = [];
    this.selectedActiveFilters = value;
    this.onSelectedFilters.emit(this.selectedActiveFilters);
    // this.eventService.changeFilter(this.selected);
  }

  @HostListener('document:click', ['$event'])
  clickOutSide(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
    }
  }

  goManage(): void {
    this.divToggle('manage');
    this.filterName = '';
    this.selectRule = '';
    this.clearFiltersField();
    this.advancedFilterId = undefined;
  }

  closeDrawer(): void {
    this.filterName = '';
    this.selectRule = '';
    this.showIndex = -1;
    this.divToggle('');
    this.drawer.close();
    this.clearFiltersField();
    this.resetAddFilterFields();
  }

  toggleAddSectionFromManage(): void {
    this.divToggle('addFilter');
    this.advancedFiltersForm.reset();
    this.advancedFilterId = undefined;
  }

  stringLengthConcat(string: string) {
    return string?.length > this.MAX_CHARS ? '...' + string?.substring(0, this.MAX_CHARS) : string;
  }

  filterValueOutputString(filter: { filterEntity: FilterEntities; value: any[] }) {
    if (!filter?.value?.length) {
      return '';
    }

    if (filter?.filterEntity === FilterEntities.INVENTORY_LOCATION) {
      const result = filter.value.map((val) => {
        let res = this.inventoryLocationsNamesMap[val];
        if (!res) {
          this.inventoryLocationsNamesMap[val] = this.advancedFilterService.inventoryLocationsOptions?.find(
            (option) => option.value === val,
          )?.label;
          res = this.inventoryLocationsNamesMap[val];
        }

        return res;
      });

      return result.join(', ');
    } else {
      return filter.value.map((value) => (value?.name ? value.name : value)).join(', ');
    }
  }

  private checkValidation(): boolean {
    return (this.isFormValid = this.advancedFiltersForm.value.filters?.length > 0);
  }

  private static convertFilterConditionOperatorUItoDB(condition: FilterConditionOperators): {
    operator: BackendFilterConditionOperators;
    subOperator?: BackendFilterConditionSubOperators;
  } {
    switch (condition) {
      case FilterConditionOperators.IS:
        return { operator: BackendFilterConditionOperators.IN };
      case FilterConditionOperators.IS_NOT:
        return { operator: BackendFilterConditionOperators.NOT_IN };
      case FilterConditionOperators.INCLUDE:
        return { operator: BackendFilterConditionOperators.IN };
      case FilterConditionOperators.EXCLUDE:
        return { operator: BackendFilterConditionOperators.NOT_IN };
      case FilterConditionOperators.STARTS_WITH:
        return { operator: BackendFilterConditionOperators.STARTS_WITH };
      case FilterConditionOperators.NOT_STARTS_WITH:
        return { operator: BackendFilterConditionOperators.NOT_STARTS_WITH };
      case FilterConditionOperators.CONTAINS:
        return { operator: BackendFilterConditionOperators.CONTAINS };
      case FilterConditionOperators.NOT_CONTAINS:
        return { operator: BackendFilterConditionOperators.NOT_CONTAINS };
      case FilterConditionOperators.EQUALS:
        return {
          operator: BackendFilterConditionOperators.IN,
          subOperator: BackendFilterConditionSubOperators.EQUALS,
        };
      case FilterConditionOperators.IS_MORE_THAN:
        return {
          operator: BackendFilterConditionOperators.IN,
          subOperator: BackendFilterConditionSubOperators.IS_MORE_THAN,
        };
      case FilterConditionOperators.IS_LESS_THAN:
        return {
          operator: BackendFilterConditionOperators.IN,
          subOperator: BackendFilterConditionSubOperators.IS_LESS_THAN,
        };
      case FilterConditionOperators.IS_MORE_THAN_OR_EQUAL:
        return {
          operator: BackendFilterConditionOperators.IN,
          subOperator: BackendFilterConditionSubOperators.IS_MORE_THAN_OR_EQUAL,
        };
      case FilterConditionOperators.IS_LESS_THAN_OR_EQUAL:
        return {
          operator: BackendFilterConditionOperators.IN,
          subOperator: BackendFilterConditionSubOperators.IS_LESS_THAN_OR_EQUAL,
        };
    }
  }

  public convertFilterConditionOperatorDBtoUI(
    operator: string,
    subOperator: string,
    filterEntity: FilterEntities,
  ): FilterConditionOperators {
    if (!subOperator) {
      if (operator === BackendFilterConditionOperators.IN && filterEntity === FilterEntities.PACKAGE_NAME) {
        return FilterConditionOperators.IS;
      } else if (operator === BackendFilterConditionOperators.IN) {
        return FilterConditionOperators.INCLUDE;
      } else if (operator === BackendFilterConditionOperators.NOT_IN && filterEntity === FilterEntities.PACKAGE_NAME) {
        return FilterConditionOperators.IS_NOT;
      } else if (operator === BackendFilterConditionOperators.NOT_IN) {
        return FilterConditionOperators.EXCLUDE;
      } else if (operator === BackendFilterConditionOperators.STARTS_WITH) {
        return FilterConditionOperators.STARTS_WITH;
      } else if (operator === BackendFilterConditionOperators.NOT_STARTS_WITH) {
        return FilterConditionOperators.NOT_STARTS_WITH;
      } else if (operator === BackendFilterConditionOperators.CONTAINS) {
        return FilterConditionOperators.CONTAINS;
      } else if (operator === BackendFilterConditionOperators.NOT_CONTAINS) {
        return FilterConditionOperators.NOT_CONTAINS;
      }
    } else {
      switch (subOperator) {
        case BackendFilterConditionSubOperators.EQUALS:
          return FilterConditionOperators.EQUALS;
        case BackendFilterConditionSubOperators.IS_MORE_THAN:
          return FilterConditionOperators.IS_MORE_THAN;
        case BackendFilterConditionSubOperators.IS_LESS_THAN:
          return FilterConditionOperators.IS_LESS_THAN;
        case BackendFilterConditionSubOperators.IS_MORE_THAN_OR_EQUAL:
          return FilterConditionOperators.IS_MORE_THAN_OR_EQUAL;
        case BackendFilterConditionSubOperators.IS_LESS_THAN_OR_EQUAL:
          return FilterConditionOperators.IS_LESS_THAN_OR_EQUAL;
      }
    }
  }

  convertFilterEntityDBtoUI(dbEntity: string): FilterEntities {
    switch (dbEntity) {
      case BackendFilterEntities.PRODUCT_TAG_ID:
        return FilterEntities.TAG;
      case BackendFilterEntities.ORDER_TAG_ID:
        return FilterEntities.TAG;
      case BackendFilterEntities.PRODUCT_TAG_NAME:
        return FilterEntities.TAG;
      case BackendFilterEntities.ORDER_TAG_NAME:
        return FilterEntities.TAG;
      case BackendFilterEntities.SKU:
      case 'skuCount':
        return FilterEntities.SKU;
      case BackendFilterEntities.PACKAGE_NAME:
        return FilterEntities.PACKAGE_NAME;
      case BackendFilterEntities.DELIVERY_METHOD:
        return FilterEntities.DELIVERY_METHOD;
      case BackendFilterEntities.ITEMS_QUANTITY:
        return FilterEntities.ITEMS_QUANTITY;
      case BackendFilterEntities.LINE_ITEMS_QUANTITY:
        return FilterEntities.LINE_ITEMS_QUANTITY;
      case BackendFilterEntities.INVENTORY_LOCATION:
        return FilterEntities.INVENTORY_LOCATION;
      case BackendFilterEntities.COLOR_CODING:
        return FilterEntities.COLOR_CODING;
      case BackendFilterEntities.SHIP_TO_COUNTRY:
        return FilterEntities.SHIP_TO_COUNTRY;
      case BackendFilterEntities.SHIP_TO_STATE:
        return FilterEntities.SHIP_TO_STATE;
      case BackendFilterEntities.ORDER_NOTE:
        return FilterEntities.ORDER_NOTE;
    }
  }

  convertFilterEntityUItoDB(filterEntity: FilterEntities): BackendFilterEntities {
    switch (filterEntity) {
      case FilterEntities.SKU:
        return BackendFilterEntities.SKU;
      case FilterEntities.PACKAGE_NAME:
        return BackendFilterEntities.PACKAGE_NAME;
      case FilterEntities.DELIVERY_METHOD:
        return BackendFilterEntities.DELIVERY_METHOD;
      case FilterEntities.ITEMS_QUANTITY:
        return BackendFilterEntities.ITEMS_QUANTITY;
      case FilterEntities.LINE_ITEMS_QUANTITY:
        return BackendFilterEntities.LINE_ITEMS_QUANTITY;
      case FilterEntities.INVENTORY_LOCATION:
        return BackendFilterEntities.INVENTORY_LOCATION;
      case FilterEntities.COLOR_CODING:
        return BackendFilterEntities.COLOR_CODING;
      case FilterEntities.SHIP_TO_COUNTRY:
        return BackendFilterEntities.SHIP_TO_COUNTRY;
      case FilterEntities.SHIP_TO_STATE:
        return BackendFilterEntities.SHIP_TO_STATE;
      case FilterEntities.ORDER_NOTE:
        return BackendFilterEntities.ORDER_NOTE;
    }
  }

  isStoreAutocompleteObjects(dbEntity: string) {
    if (dbEntity === 'orderTags.id' || dbEntity === 'productTags.id') {
      return true;
    }
    return false;
  }

  parceFilterValues(values: any[], entity: FilterEntities) {
    if (!values?.length) {
      return [];
    } else if (values.length >= 1) {
      return [values];
    }
  }

  public divToggle(str: string): void {
    this.showDiv = str;
  }

  entityChanged(data: { lsbel: string; value: FilterEntities }) {
    this.advancedFiltersForm.controls.filterEntity.setValue(data.value);
    this.advancedFiltersForm.controls.filterEntity.markAsDirty();
    this.advancedFiltersForm.controls.conditionEntity.setValue(null);
    this.advancedFiltersForm.controls.conditionEntity.setValidators(Validators.required);
    this.advancedFiltersForm.controls.conditionEntity.updateValueAndValidity();

    this.advancedFiltersForm.controls.param1.setValue(null);
    this.advancedFiltersForm.controls.param2.setValue(null);
    this.advancedFiltersForm.controls.param1.setValidators(Validators.required);
    // this.advancedFiltersForm.controls.param1.updateValueAndValidity();

    // this.settingsEditPackageService.validateBoxRulesDataError = null; // TODO: fogure out this

    if (data.value === FilterEntities.ITEMS_QUANTITY) {
      this.advancedFiltersForm.controls.param1.setValidators([Validators.required, Validators.min(0.001)]);
    }
  }

  conditionChanged(data: { label: string; value: FilterConditionOperators }) {
    this.advancedFiltersForm.controls.conditionEntity.setValue(data.value);
    this.advancedFiltersForm.controls.conditionEntity.markAsDirty();

    const entityValue = this.advancedFiltersForm.controls.filterEntity.value;
    const conditionValue = this.advancedFiltersForm.controls.conditionEntity.value;

    const params = this.advancedFilterService.getParamsBySelectedCondition(entityValue, conditionValue);
    params.forEach((p, index) => {
      const defaultValue = this.getDefaultValueByInputType(p.fieldType);
      if (defaultValue !== null) {
        this.advancedFiltersForm.controls[`param${index + 1}`].setValue(defaultValue);
      } else {
        this.advancedFiltersForm.controls[`param${index + 1}`].setValue('');
      }
    });
    if (params.length === 1) {
      this.advancedFiltersForm.controls.param2.setValue('');
      this.advancedFiltersForm.controls.param2.setValidators(Validators.required);
    }

    this.autocompleteList = [];
    const autocompleteParam = params.find(
      (p) => p.fieldType === InputType.STRING && p.fieldSubType === InputSubType.AUTOCOMPLETE,
    );
    if (autocompleteParam) {
      this.loadAutocomplete();
    } else {
      this.closeAutocomplete();
    }

    // this.settingsEditPackageService.validateBoxRulesDataError = null;
  }

  private loadAutocomplete(): void {
    console.log('loadTagsAutocomplete');
    if (this.controlsSubscription$) {
      this.controlsSubscription$.unsubscribe();
      this.controlsSubscription$ = null;
    }

    const subscription = this.advancedFiltersForm.controls.param2.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {
          this.isLoadingAutoComplete = true;
        }),
        switchMap(() => {
          console.log('Param2: ', this.advancedFiltersForm.controls.param2);
          console.log('Filter entity: ', this.advancedFiltersForm.value.filterEntity);

          // let autocompleteSearchValue = this.getAutocompleteSearchValue();
          return this.advancedFilterService
            .getAutoComplete(
              typeof this.advancedFiltersForm.controls.param2.value === 'string'
                ? this.advancedFiltersForm.controls.param2.value
                : '',
              this.advancedFiltersForm.value.filterEntity,
            )
            .pipe(
              finalize(() => {
                this.isLoadingAutoComplete = false;
              }),
            );
        }),
      )
      .subscribe((data: { orderTags: OrderTag[]; productTags: ProductTag[]; skus: string[] }) => {
        console.log('autocomplete data: ', data);
        if (this.advancedFiltersForm.value.filterEntity === FilterEntities.TAG) {
          this.autocompleteList = data?.orderTags
            ?.map((tag) => ({
              value: tag.id,
              label: tag.name,
              type: 'orderTag',
            }))
            .concat(
              data?.productTags?.map((tag) => ({
                value: tag.id,
                label: tag.name,
                type: 'productTag',
              })),
            );
        } else if (this.advancedFiltersForm.value.filterEntity === FilterEntities.SKU) {
          this.autocompleteList = data?.skus?.filter((sku) => !!sku).map((sku) => ({ value: sku, label: sku }));
        }
        console.log('autocomplete data: ', this.autocompleteList);
      });

    this.controlsSubscription$ = subscription;
  }

  private closeAutocomplete(): void {
    if (this.controlsSubscription$) {
      this.controlsSubscription$.unsubscribe();
      this.controlsSubscription$ = null;
    }
  }

  private getAutocompleteSearchValue() {
    return this.advancedFiltersForm.controls.param2.value;
  }

  getDefaultValueByInputType(inputType: InputType) {
    switch (inputType) {
      case InputType.NUMBER: {
        return 0;
      }
      case InputType.COLOR: {
        return [ColorEnum.NO_COLOR];
      }
      default: {
        return null;
      }
    }
  }

  getParameterControlValue(paramIndex: number) {
    return this.advancedFiltersForm.controls['param' + (paramIndex + 1)].value;
  }

  isMissingAutocompleteResults() {
    const searchTerm = this.getParameterControlValue(1);
    const autocompleteResults = this.autocompleteList?.map((val) => val?.label)?.filter((val) => !!val) ?? [];
    console.log('isMissingAutocompleteResults: ', autocompleteResults);
    return !autocompleteResults.filter((item) => item.toLowerCase().includes(searchTerm?.toLowerCase()))?.length;
  }

  getAutocompleteMatchingResults() {
    const searchTerm = this.getParameterControlValue(1);
    const autocompleteResults = this.autocompleteList?.map((val) => val?.label)?.filter((val) => !!val) ?? [];
    const res =
      this.autocompleteList?.filter(
        (item) => item?.label && item?.value && item.label.toLowerCase().includes(searchTerm?.toLowerCase()),
      ) ?? [];
    console.log('getAutocompleteResultsLabels: ', res);
    return res;
  }

  getAutocompleteResultString(val: AutocompleteResult) {
    return `${val.label} ${val?.type ? ' | ' + val.type : ''}`;
  }

  isTextOverflowed(event: HTMLElement | any) {
    const offsetWidth = event?.elementRef.nativeElement?.firstElementChild?.offsetWidth ?? 0;
    return !(offsetWidth < this.maximumAutocompleteWidth);
  }

  onAutocompleteResultSelect(result: AutocompleteResult) {
    const param2Control = this.advancedFiltersForm.controls.param2;
    param2Control.reset('', { onlySelf: true });

    const currentlySelectedOptions: AutocompleteResult[] = [...this.advancedFiltersForm.controls.param1.value];
    const optionExists = this.advancedFiltersForm.controls.param1?.value?.find?.(
      (val: AutocompleteResult) => val.value === result.value && (!result.type || val.type === result.type),
    );

    if (!optionExists) {
      currentlySelectedOptions.push(result);
      this.advancedFiltersForm.controls.param1.setValue(currentlySelectedOptions);
    }

    console.log('After select: ', this.advancedFiltersForm.controls.param1.value);
  }

  onAutocompleteResultRemove(result: AutocompleteResult) {
    console.log('Autocomplete remove: ', result);
    const currentlySelectedOptions: AutocompleteResult[] = [...this.advancedFiltersForm.controls.param1.value];
    const updatedSelectedOptions = currentlySelectedOptions.filter((val) => {
      return !(val.value === result.value && (!result.type || val.type === result.type));
    });

    this.advancedFiltersForm.controls.param1.setValue(updatedSelectedOptions);
    console.log('After remove: ', this.advancedFiltersForm.controls.param1.value);
  }

  getFilterEntityDefaultOption() {
    const currentFilterEntityValue = this.advancedFiltersForm.controls.filterEntity.value;
    const currentFilterEntityLabel = this.advancedFilterService.filterEntityOptions?.find(
      (val) => val?.value === currentFilterEntityValue,
    )?.label;

    const result = this.advancedFiltersForm.controls.filterEntity.value
      ? {
          label: currentFilterEntityLabel ?? 'Error',
          value: currentFilterEntityValue,
        }
      : null;

    return result;
  }

  getFilterConditionEntityDisplay(filterEntity: FilterEntities) {
    switch (filterEntity) {
      case FilterEntities.TAG:
        return FilterEntitiesDisplay.TAG;
      case FilterEntities.SKU:
      case 'skuCount' as FilterEntities:
        return FilterEntitiesDisplay.SKU;
      case FilterEntities.PACKAGE_NAME:
        return FilterEntitiesDisplay.PACKAGE_NAME;
      case FilterEntities.LINE_ITEMS_QUANTITY:
        return FilterEntitiesDisplay.LINE_ITEMS_QUANTITY;
      case FilterEntities.ITEMS_QUANTITY:
        return FilterEntitiesDisplay.ITEMS_QUANTITY;
      case FilterEntities.DELIVERY_METHOD:
        return FilterEntitiesDisplay.DELIVERY_METHOD;
      case FilterEntities.INVENTORY_LOCATION:
        return FilterEntitiesDisplay.INVENTORY_LOCATION;
      case FilterEntities.COLOR_CODING:
        return FilterEntitiesDisplay.COLOR_CODING;
      case FilterEntities.SHIP_TO_COUNTRY:
        return FilterEntitiesDisplay.SHIP_TO_COUNTRY;
      case FilterEntities.SHIP_TO_STATE:
        return FilterEntitiesDisplay.SHIP_TO_STATE;
      case FilterEntities.ORDER_NOTE:
        return FilterEntitiesDisplay.ORDER_NOTE;
      default:
        return FilterEntitiesDisplay.UNKNOWN;
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    let listName;
    if (this.pinnedArray?.find((filterItem) => filterItem.id === event.item.data.id)) {
      listName = 'pinnedArray';
    } else {
      listName = 'regularAdvancedFilterArray';
      event.previousIndex = event.previousIndex - this.pinnedArray.length;
      event.currentIndex = event.currentIndex - this.pinnedArray.length;
    }
    const list = this[listName]?.slice();
    moveItemInArray(list, event.previousIndex, event.currentIndex);
    this[listName] = list;
    if (listName === 'pinnedArray') {
      localStorage.setItem(this.localStoragePinnedArrayKey, JSON.stringify(this.pinnedArray));
      this.onPinnedArrayUpdate.emit(this.pinnedArray);
    } else {
      localStorage.setItem(
        this.localStoragePriorityUnPinnedArrayKey,
        JSON.stringify(this.regularAdvancedFilterArray.map((x) => x.id)),
      );
      this.onAdvancedFiltersArrayUpdate.emit(this.regularAdvancedFilterArray);
    }
  }
}
